import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_ITEM_TAG,
  DELETE_ITEM_TAG,
  GET_ALL_ITEM_TAGS,
  GET_ALL_ITEM_TAGS_LIST,
  GET_ITEM_TAG_DETAILS,
  UPDATE_ITEM_TAG,
  UPDATE_ITEM_TAG_STATUS,
} from "helpers/url_helper"

export const getItemTagsList = createAsyncThunk(
  GET_ALL_ITEM_TAGS_LIST,
  async payload => {
    const response = await get(GET_ALL_ITEM_TAGS_LIST, payload)
    return response
  }
)

export const getItemTags = createAsyncThunk(
  GET_ALL_ITEM_TAGS,
  async payload => {
    const response = await post(GET_ALL_ITEM_TAGS, payload)
    return response
  }
)

export const updateItemTagStatus = createAsyncThunk(
  UPDATE_ITEM_TAG_STATUS,
  async payload => {
    const response = await patch(UPDATE_ITEM_TAG_STATUS, payload)
    return response
  }
)

export const deleteItemTag = createAsyncThunk(
  DELETE_ITEM_TAG,
  async payload => {
    const response = await del(DELETE_ITEM_TAG, payload)
    return response
  }
)

export const addItemTag = createAsyncThunk(ADD_ITEM_TAG, async payload => {
  const response = await post(ADD_ITEM_TAG, payload)
  return response
})

export const updateItemTag = createAsyncThunk(UPDATE_ITEM_TAG, async payload => {
  const response = await put(UPDATE_ITEM_TAG, payload)
  return response
})

export const getItemTagDetails = createAsyncThunk(
  GET_ITEM_TAG_DETAILS,
  async payload => {
    const response = await post(GET_ITEM_TAG_DETAILS, payload)
    return response
  }
)
